<template>
  <v-card class="d-flex align-center justify-center pa-10" outlined>
    <div>
      <div class="d-flex justify-center">
        <v-img class="mb-3" position="center center" src="https://hub.swiset.com/wp-content/uploads/2021/02/Swiset-Pro-Feature.png" max-width="77px" contain/>
      </div>
      <h2 class="text-center">{{ $t('title_ProStatAlert') }}</h2>
      <p class="text-center">{{ $t('description_ProStatAlert') }}</p>
      <v-btn class="button-convert" style="width: 100%" @click="goToPro">{{ $t('btnSeeBenefits') }} »</v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ProStatAlert",
  methods: {
    goToPro() {
      this.$emit('goToPro');
    }
  }
}
</script>



<style scoped>
</style>
